import React, { type FC } from 'react'

interface IconChevronsRightProps {
  width?: string
  height?: string
}

const IconChevronsRight: FC<IconChevronsRightProps> = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M15.5445 8.79448C15.9839 8.35503 15.9839 7.64136 15.5445 7.2019L8.79448 0.451904C8.35503 0.0124512 7.64136 0.0124512 7.2019 0.451904C6.76245 0.891357 6.76245 1.60503 7.2019 2.04448L13.1574 7.99995L7.20542 13.9554C6.76597 14.3949 6.76597 15.1085 7.20542 15.548C7.64487 15.9875 8.35855 15.9875 8.798 15.548L15.548 8.798L15.5445 8.79448ZM2.04448 15.5445L8.79448 8.79448C9.23394 8.35503 9.23394 7.64136 8.79448 7.2019L2.04448 0.451904C1.60503 0.0124512 0.891357 0.0124512 0.451904 0.451904C0.0124512 0.891357 0.0124512 1.60503 0.451904 2.04448L6.40737 7.99995L0.45542 13.9554C0.0159669 14.3949 0.0159669 15.1085 0.45542 15.548C0.894873 15.9875 1.60854 15.9875 2.048 15.548L2.04448 15.5445Z"
        fill="currentColor"
        shapeRendering="geometricPrecision"
      />
    </svg>
  )
}

export default IconChevronsRight
